import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { DateField, DateRangeField } from '@/components/ui/DateField';
import { AmountField } from '@/components/ui/AmountField';
import { SearchSelect } from '@/components/ui/SearchSelect';
import { TagInput } from '@/components/ui/TagInput';
import { DraftStatus } from '@/components/ui/DraftStatus';
import { OPTIONS, FIELD_HOME } from '../fields/model';
import { Section, Code } from './Section';
export function FieldPatternsSection() {
  const { hash } = useLocation(),
    [date, setDate] = useState('28.10.2026'),
    [range, setRange] = useState({ from: '28.10.2026', to: '30.10.2026' }),
    [amount, setAmount] = useState('18 750,00'),
    [owner, setOwner] = useState<string | null>('team-12'),
    [tags, setTags] = useState(['Планирование', 'Осень']),
    [pending, setPending] = useState('');
  useEffect(() => {
    if (hash !== '#field-patterns') return;
    let active = true;
    const align = () => {
      if (active)
        document.getElementById('field-patterns')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash]);
  return (
    <Section
      id="field-patterns"
      title="Сложные поля"
      lead="Дата и период, точная сумма, поиск в длинном списке и теги. Один вид для форм любого сервиса."
    >
      <div className="grid gap-6 md:grid-cols-2">
        <div className="rounded-lg border border-line bg-card p-5">
          <h3 className="mb-5 type-heading">Дата и период</h3>
          <DateField label="Дата проверки" value={date} onChange={setDate} />
          <div className="mt-5 border-t border-line pt-5">
            <DateRangeField label="Период работ" value={range} onChange={setRange} />
          </div>
          <p className="mt-5">
            <Code>DateField · DateRangeField · клавиатура</Code>
          </p>
        </div>
        <div className="rounded-lg border border-line bg-card p-5">
          <h3 className="mb-5 type-heading">Сумма и поиск</h3>
          <AmountField label="Сумма, RUB" value={amount} currency="RUB" onChange={setAmount} />
          <div className="mt-5">
            <SearchSelect label="Рабочая группа" value={owner} onChange={setOwner} options={OPTIONS} />
          </div>
          <p className="mt-5">
            <Code>AmountField · SearchSelect · 240 вариантов</Code>
          </p>
        </div>
      </div>
      <div className="grid gap-6 rounded-lg border border-line bg-card p-5 md:grid-cols-2">
        <div>
          <h3 className="mb-5 type-heading">Теги</h3>
          <TagInput
            label="Добавить теги"
            value={tags}
            onChange={setTags}
            inputValue={pending}
            onInputChange={setPending}
          />
          <p className="mt-5">
            <Code>TagInput · добавление и удаление с клавиатуры</Code>
          </p>
        </div>
        <div className="flex flex-col items-start gap-4">
          <h3 className="type-heading">Автосохранение черновика</h3>
          <DraftStatus snapshot={{ status: 'initial', savedAt: null, error: null }} onRetry={() => {}} />
          <p className="text-sm text-fg-muted">
            В образце можно проверить восстановление, две независимые записи и повтор после сбоя.
          </p>
          <Link
            to={FIELD_HOME}
            className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            Открыть образец
            <ArrowRight className="size-4" />
          </Link>
          <Code>DraftStatus · createDraftStore</Code>
        </div>
      </div>
    </Section>
  );
}
